<template>
  <v-container grid-list-xl class="pa-5">
    <m-card-list
      two-line
      title="Kelola Saldo Cuti"
      label-cari="Cari Saldo Cuti"
      search
      :filterGenerate="isCan('cuti-saldo.generate')"
      :useGenCutiUser="true"
      @generateCuti="generateCuti"
      :kategories="kategories"
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
            search => {
              textSearch = search;
              load();
            }
          "
      @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
      @add="add"
    >
      <template v-slot:action_tools>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              depressed
              class="rounded mr-3 pa-5 grey lighten-3"
              small
              icon
              @click="openFilter"
            >
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filter Kategori Cuti</span>
        </v-tooltip>
      </template>
      <template v-slot:action_ext>
        <v-btn depressed class="ml-2" color="primary" @click="onUpload"><v-icon left>mdi-upload</v-icon> Unggah Data</v-btn>
      </template>
      <template v-slot:items="{ props, item, index }">
        <tr>
          <td class="font-weight-bold">{{ getDeepObj(item, "nama") || getDeepObj(item, "users.nama") }}</td>
          <td>{{ getDeepObj(item, "kategori") || getDeepObj(item, "cuti_kategori.nama") }}</td>
          <td>
            {{ item.sisa || 0 }}
          </td>
          <td>
            {{ item.jumlah || 0 }}
          </td>
          <td>{{ Number(item.masa_kerja || 0) > 0 ? toCy(pVal(item, "masa_kerja")) : '-' }}</td>
          <td>
            <m-menu v-if="item.cuti_saldo_id" left style="float:right" :items="more_menu" :object="item" />
          </td>
        </tr>
      </template>
    </m-card-list>
    <form-upload
      ref="upload"
      :max="1500"
      @download="onDownloadTemplate"
      @reload="load"
    />
    <ChangeDlg ref="dlg" />
    <ChangeSaldo ref="dlgChange" @reload="load"/>
    <FilterSaldo ref="dlgFilter" @filter="onFilter" />
  </v-container>
</template>

<script>
// import { isCan } from "@/tools";
import FormUpload from "../components/Upload.vue"
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";
import ChangeSaldo from "../components/EditSaldo"
import FilterSaldo from "../components/Filter.vue"
import {isCan} from "@/tools";
import { toCY } from "../../../tools";

export default {
  components: {
    ChangeDlg,
    BlockCard,
    ChangeSaldo,
    FormUpload,
    FilterSaldo
  },
  data() {
    return {
      items: [],
      kategories: [],
      textSearch: null,
      page: null,
      cp: 1,
      editable: {},
      headers: [
        { text: "Nama Lengkap", align: "left", value: "nama" },
        { text: "Kategori Cuti", align: "left", value: "cuti_kategori" },
        { text: "Sisa Cuti", align: "left", value: "value" },
        { text: "Jatah Cuti", align: "left", value: "value" },
        { text: "Min Masa Kerja", align: "left", value: "value" },
        { text: "Aksi", align: "left", value: "value", sortable: false }
      ],
      more_menu: [
        {
          title: 'Ubah',
          click: (i, o) => this.edit(o),
          check: () => isCan(`jadwal.${this.keyAkses}update`),
        },
      ],
      filters: {}
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("saldoCuti/get", {
          organisasi_id: this.organisasi_id,
          params: Object.assign({}, {
            page: this.cp,
            keyword: this.textSearch
          }, this.filters)
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    generateCuti(data) {
      let kategories = []

      if (data.kategori.cuti_kategori_id === 0) {
        let ids = data.kategories.map((s) => s.cuti_kategori_id)
        ids.splice(0, 1)
        kategories = ids
      } else {
        kategories = [data.kategori.cuti_kategori_id]
      }

      let dataCuti = {
        ids: kategories,
        tahun: new Date().getFullYear()
      };

      if (data && data.user && data.user.user_id &&  data.user.user_id !== 0) {
        this.$set(dataCuti, 'user_id', data.user.user_id)
      }

      return this.$store
        .dispatch("saldoCuti/generate", {
          obj: dataCuti,
          organisasi_id: this.organisasi_id
        })
        .then(res => {
          this.page = res.data;
          this.kategories = res.data.data;
          this.load();
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      console.log(item)
      this.$refs.dlgChange.open(item)
    },
    onHapus(item) {
      this.$delete(this.editable, item.cuti_saldo_id)
    },
    onUpload() {
      this.$refs.upload.open();

      this.$nextTick(() => {
        this.$refs.upload.reset();
        this.$refs.upload.organisasi = this.organisasi_id;
      });
    },
    onDownloadTemplate() {
      this.$store
        .dispatch("saldoCuti/unduhTemplate", {
          id: this.organisasi_id,
        })
        .then(url => {
          window.open(url);
        });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Data Saldo Cuti ${item.nama} yang telah di masukkan ke data user juga akan dihapus oleh sistem
          </div>
        </div>


        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
         ${item.nama}<br>
        </div>

      `
      )
        .then(() => this.$store.dispatch("saldoCuti/drop", item.atribut_id))
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    onUpdateSaldo(item) {
      let params = {
        jml_saldo: Number(this.editable && this.editable[item.cuti_saldo_id] && this.editable[item.cuti_saldo_id]['jml_saldo'])
      }

      this.$store.dispatch('saldoCuti/update',
        {
          organisasi_id: this.organisasi_id,
          obj: {
            params: params,
            id: item.cuti_saldo_id
          }
        }
      ).then(() => {
        this.$success('Saldo berhasil di perbarui')
        this.$delete(this.editable, item.cuti_saldo_id)
        this.load()
      })
    },
    toCy(value) {
      return toCY(value)
    },
    openFilter() {
      this.$refs.dlgFilter.open()
    },
    onFilter(data) {
      this.filters = {}
      if (data && data.cuti_kategori_id && Number(data.cuti_kategori_id) > 0) {
        this.$set(this.filters, 'cuti_kategori_id', data.cuti_kategori_id)
      }
      this.$refs.dlgFilter.close()
      this.cp = 1
      this.load();
    }
  }
};
</script>
